import LinkedAssociations from './LinkedAssociations.component';

export default LinkedAssociations;